<template>
    <div>
      <div class="uk-section">
        <h1 class="uk-text-center">404 Page not found</h1>
      </div>
    </div>
</template>

<script>
    export default {
        name: "PageNotFound"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageNotFound.vue